const T_PREFIX = "cookie-policy";

export const cookiePolicyTrns = {
  title: `${T_PREFIX}.title`,

  introductionTitle: `${T_PREFIX}.introduction.title`,
  introductionContent: `${T_PREFIX}.introduction.content`,

  purposeTitle: `${T_PREFIX}.purpose-of-this-policy.title`,
  purposeContent: `${T_PREFIX}.purpose-of-this-policy.content`,

  whatCookiesTitle: `${T_PREFIX}.what-are-cookies.title`,
  whatCookiesContent: `${T_PREFIX}.what-are-cookies.content`,

  cookiesImproveTitle: `${T_PREFIX}.how-cookies-improve.title`,
  cookiesImproveContent: `${T_PREFIX}.how-cookies-improve.content`,

  cookiesImportanceTitle: `${T_PREFIX}.why-important.title`,
  cookiesImportanceContent: `${T_PREFIX}.why-important.content`,

  consentTitle: `${T_PREFIX}.your-consent.title`,
  consentContent: `${T_PREFIX}.your-consent.content`,

  conclusionTitle: `${T_PREFIX}.conclusion.title`,
  conclusionContent: `${T_PREFIX}.conclusion.content`,

  cookiesUsageTitle: `${T_PREFIX}.how-we-use-cookies.title`,
  cookiesUsageContent: `${T_PREFIX}.how-we-use-cookies.content`,

  ensureFunctionalityTitle: `${T_PREFIX}.ensuring-functionality.title`,
  ensureFunctionalityContent: `${T_PREFIX}.ensuring-functionality.content`,

  improvePerformanceTitle: `${T_PREFIX}.improving-performance.title`,
  improvePerformanceContent: `${T_PREFIX}.improving-performance.content`,

  personalizationTitle: `${T_PREFIX}.content-personalization.title`,
  personalizationContent: `${T_PREFIX}.content-personalization.content`,

  trafficAnalysisTitle: `${T_PREFIX}.traffic-analysis.title`,
  trafficAnalysisContent: `${T_PREFIX}.traffic-analysis.content`,

  advertisingTitle: `${T_PREFIX}.advertising.title`,
  advertisingContent: `${T_PREFIX}.advertising.content`,

  manageCookiesTitle: `${T_PREFIX}.managing-cookies.title`,
  manageCookiesContent: `${T_PREFIX}.managing-cookies.content`,

  importantNotesTitle: `${T_PREFIX}.important-notes.title`,
  importantNotesContent: `${T_PREFIX}.important-notes.content`,

  alternativeMethodsTitle: `${T_PREFIX}.alternative-methods.title`,
  alternativeMethodsContent: `${T_PREFIX}.alternative-methods.content`,

  toolsAndResourcesTitle: `${T_PREFIX}.tools-and-resources.title`,
  toolsAndResourcesContent: `${T_PREFIX}.tools-and-resources.content`,

  policyChangesTitle: `${T_PREFIX}.changes-to-policy.title`,
  policyChangesContent: `${T_PREFIX}.changes-to-policy.content`,

  publishingChangesTitle: `${T_PREFIX}.publishing-changes.title`,
  publishingChangesContent: `${T_PREFIX}.publishing-changes.content`,

  typesOfChangesTitle: `${T_PREFIX}.types-of-changes.title`,
  typesOfChangesContent: `${T_PREFIX}.types-of-changes.content`,

  stayInformedTitle: `${T_PREFIX}.stay-informed.title`,
  stayInformedContent: `${T_PREFIX}.stay-informed.content`,

  contactInfoTitle: `${T_PREFIX}.contact-information.title`,
  contactInfoContent: `${T_PREFIX}.contact-information.content`,
};
